import React, { useEffect, useState } from "react";
import GenericCrudPage from "../common/GenericCrudPage";
import {
  getStudentGroups,
  createStudentGroup,
  updateStudentGroup,
  deleteStudentGroup,
} from "../../../services/StudentGroupService";
import { getClasses } from "../../../services/ClassService";
import { useTranslation } from "react-i18next";

const StudentGroups = () => {
  const { t } = useTranslation();
  const [classes, setClasses] = useState([]);

  useEffect(() => {
    getClasses({ page: 1, limit: 200 }).then((res) => setClasses(res.data?.data || [])).catch(() => {});
  }, []);

  const classLabel = (id) => classes.find((c) => c.id === id)?.name || "-";

  return (
    <GenericCrudPage
      permissionModule="STUDENT_GROUP"
      title={t("pages.studentGroups.title")}
      breadcrumbLabel={t("pages.studentGroups.breadcrumb")}
      addLabel={t("pages.studentGroups.addLabel")}
      searchPlaceholder={t("common.ui.rechercherCodeNom")}
      defaultSort={{ by: "name", dir: "asc" }}
      api={{
        list: getStudentGroups,
        create: createStudentGroup,
        update: updateStudentGroup,
        remove: deleteStudentGroup,
      }}
      filters={[{ key: "class_id", label: t("common.fields.allClasses"), options: classes.map((c) => ({ value: c.id, label: c.name })) }]}
      columns={[
        { key: "code", label: t("common.fields.code"), sortable: true },
        { key: "name", label: t("common.fields.name"), sortable: true },
        { key: "class_id", label: t("common.fields.class"), render: (row) => classLabel(row.class_id) },
        { key: "capacity", label: t("common.fields.capacity"), render: (row) => row.capacity ?? "-" },
      ]}
      fields={[
        { key: "class_id", label: t("common.fields.class"), type: "select", required: true, options: classes.map((c) => ({ value: c.id, label: c.name })) },
        { key: "code", label: t("common.fields.code"), type: "text", required: true, placeholder: "TD1", maxLength: 20 },
        { key: "name", label: t("common.fields.name"), type: "text", required: true, placeholder: t("pages.studentGroups.groupeTd1"), maxLength: 100 },
        { key: "capacity", label: t("common.fields.capacity"), type: "number", placeholder: "25" },
        { key: "is_active", label: t("common.crud.statusActive"), type: "checkbox" },
      ]}
      buildPayload={(formData) => ({
        class_id: formData.class_id,
        code: formData.code.trim(),
        name: formData.name.trim(),
        capacity: formData.capacity !== "" ? Number(formData.capacity) : null,
        is_active: formData.is_active !== undefined ? !!formData.is_active : true,
      })}
      getItemLabel={(item) => item.name}
    />
  );
};

export default StudentGroups;
